import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PlotCategory from "../pages/category/plot/page";
import CastCategory from "../pages/category/cast/page";
import NewsCategory from "../pages/category/news/page";
import PlotDetail from "../pages/detail/plot/page";
import CastDetail from "../pages/detail/cast/page";
import NewsDetail from "../pages/detail/news/page";
import SearchResults from "../pages/search/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/plot",
    element: <PlotCategory />,
  },
  {
    path: "/category/cast",
    element: <CastCategory />,
  },
  {
    path: "/category/news",
    element: <NewsCategory />,
  },
  {
    path: "/detail/plot/:id",
    element: <PlotDetail />,
  },
  {
    path: "/detail/cast/:id",
    element: <CastDetail />,
  },
  {
    path: "/detail/news/:id",
    element: <NewsDetail />,
  },
  {
    path: "/search",
    element: <SearchResults />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;